import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';

export interface UserDetails {
  id: number;
  password: string;
  userName: string;

}


interface TokenResponse {
  token: string;
}

export interface TokenPayload {
  id: number;
  userName: string;
  password: string;
  exp: number;
}



@Injectable()
export class AuthenticatorService {
  private token: string;

  constructor(private http: HttpClient, private router: Router) {}

  private saveToken(token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken')
    }
    return this.token;
  }

  public getUserDetails(): TokenPayload {
    const token = this.getToken();
    let payload: string;
    if (token) {
      payload = token.split('.')[1];
      payload = window.atob(payload);
      // console.log(payload)
      return JSON.parse(payload);

    } else {
      return null;
    }
  }

  public isLogged(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }
  // TRY AGAIN

  public login(user: TokenPayload): Observable<any> {
    const base = this.http.post('/SIPOrchestrator/authenticate', user);

    return base.pipe(
        map((data: TokenResponse) => {
          // console.log(data)
          if (data.token !== 'inavalid username/password') {
            this.saveToken(data.token);
          }
          return data;
        })
    );
  }

  public profile(): Observable<any> {
    return this.http.get('/SIPOrchestrator/profile', {
      headers: { Authorization: `${this.getToken()}`}
    });
  }

  public logOut(): void {
    this.token = ''
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('userToken');
    this.router.navigateByUrl('/');
  }

}

